// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1sxYT","head":"Table_head__3izxS","col":"Table_col__17EQs"};